import {
  useDatasetsSyncingToAnalytics,
  UseDatasetsSyncingToAnalyticsParams,
} from '@monorepo/shared/hooks/analyticsSync/useDatasetsSyncingToAnalytics';
import { DatasetType } from 'mapistry-shared';
import { useMemo } from 'react';

export const useResourceTypesSyncingToAnalytics = ({
  config,
  organizationId,
}: UseDatasetsSyncingToAnalyticsParams) => {
  const { datasetsSyncingToAnalytics, ...queryInfo } =
    useDatasetsSyncingToAnalytics({ organizationId, config });
  const resourceTypeIdsSyncingToAnalytics = useMemo(
    () =>
      datasetsSyncingToAnalytics
        ?.filter((dataset) => dataset.type === DatasetType.RESOURCE_TYPE)
        .map((dataset) => dataset.originId),
    [datasetsSyncingToAnalytics],
  );
  return {
    resourceTypeIdsSyncingToAnalytics,
    ...queryInfo,
  };
};
